import React from "react";
import { motion } from "framer-motion";

import ServicePillarsSection from "@/components/ServicePillarsSection";
import NumbersSection from "@/components/NumbersSection";
import JLPrimeSection from "@/components/JLPrimeSection";
import AboutUsSection from "@/components/AboutUsSection";
import NauticalBlueprintBackground from "@/components/NauticalBlueprintBackground";

const AgitationSection: React.FC = () => {
  return (
    <section id="servicos" className="relative bg-background pt-24 sm:pt-32">
      <NauticalBlueprintBackground />

      {/* Main Headline */}
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto mb-0 md:mb-12"
        >
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl font-medium text-primary leading-tight mb-6">
            O Mar Não Aceita Erros.
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground font-body leading-relaxed text-editorial">
            Navegar exige preparo, conhecimento e documentação impecável.
            <br className="hidden sm:block" />
            Cada detalhe importa quando a sua segurança está em jogo.
          </p>
        </motion.div>

        {/* Cards Escola Náutica + Despachante */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16 md:mb-24"
        >
          {/* Card Escola Náutica */}
          <a
            href="/escola"
            className="group relative flex flex-col overflow-visible rounded-3xl bg-white border border-slate-200 hover:border-gold/30 transition-all duration-500 hover:shadow-2xl hover:shadow-gold/10"
          >
            {/* Image Container with Pop-out effect */}
            <div className="relative h-48 sm:h-56 w-full rounded-t-3xl bg-slate-50 overflow-visible">
              <img
                src="/assets/Escolanautica.webp"
                alt="Escola Náutica"
                className="absolute inset-0 w-full h-full object-cover rounded-t-3xl transition-transform duration-500 group-hover:scale-105"
              />
              {/* Floating Badge (Chamativo mas minimalista) */}
              <div className="absolute top-4 left-4 z-20">
                <span className="bg-primary text-primary-foreground text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full tracking-widest uppercase shadow-lg border border-gold/30">
                  Escola Náutica
                </span>
              </div>
            </div>

            <div className="p-6 sm:p-8 flex flex-col items-start bg-white rounded-b-3xl">
              <h3 className="font-heading text-lg font-semibold text-primary mb-2 group-hover:text-gold transition-colors duration-300">
                Cursos & Habilitações
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                Domine as águas com confiança. Habilitação de Arrais, Mestre e Capitão com instrutores de elite.
              </p>
              <span className="inline-flex items-center gap-1.5 text-xs font-medium text-gold/80 group-hover:text-gold transition-colors">
                Explorar Cursos
                <svg className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </div>
          </a>

          {/* Card Despachante */}
          <a
            href="/despachante"
            className="group relative flex flex-col overflow-visible rounded-3xl bg-white border border-slate-200 hover:border-gold/30 transition-all duration-500 hover:shadow-2xl hover:shadow-gold/10"
          >
            {/* Image Container with Pop-out effect */}
            <div className="relative h-48 sm:h-56 w-full rounded-t-3xl bg-slate-50 overflow-visible">
              <img
                src="/assets/Despachante.webp"
                alt="Despachante Náutico"
                className="absolute inset-0 w-full h-full object-cover rounded-t-3xl transition-transform duration-500 group-hover:scale-105"
              />
              {/* Floating Badge (Chamativo mas minimalista) */}
              <div className="absolute top-4 left-4 z-20">
                <span className="bg-primary text-primary-foreground text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full tracking-widest uppercase shadow-lg border border-gold/30">
                  Despachante Náutico
                </span>
              </div>
            </div>

            <div className="p-6 sm:p-8 flex flex-col items-start bg-white rounded-b-3xl">
              <h3 className="font-heading text-lg font-semibold text-primary mb-2 group-hover:text-gold transition-colors duration-300">
                Documentação & Legalização
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                Sua única preocupação deve ser o mar. Deixe a burocracia, transferências e registros com quem entende.
              </p>
              <span className="inline-flex items-center gap-1.5 text-xs font-medium text-gold/80 group-hover:text-gold transition-colors">
                Ver Serviços
                <svg className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </div>
          </a>
        </motion.div>
      </div>

      <AboutUsSection />
      <ServicePillarsSection />
      <NumbersSection />
      <JLPrimeSection />
    </section>
  );
};

export default AgitationSection;
